module.exports = __webpack_public_path__ + "img/liuchengfenxi.ee17371a.png";